import { render, staticRenderFns } from "./ModalAddNewTeamItem.vue?vue&type=template&id=a6842c5a&scoped=true"
import script from "./ModalAddNewTeamItem.vue?vue&type=script&lang=js"
export * from "./ModalAddNewTeamItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewTeamItem.vue?vue&type=style&index=0&id=a6842c5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6842c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6842c5a')) {
      api.createRecord('a6842c5a', component.options)
    } else {
      api.reload('a6842c5a', component.options)
    }
    module.hot.accept("./ModalAddNewTeamItem.vue?vue&type=template&id=a6842c5a&scoped=true", function () {
      api.rerender('a6842c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/team/ModalAddNewTeamItem.vue"
export default component.exports